import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Avatar, Pill } from "@/components/Bits";

export default function Parents() {
  const [parents, setParents] = useState([]);
  useEffect(() => { api.get("/parents").then(r => setParents(r.data)); }, []);
  return (
    <div>
      <PageHeader eyebrow="Families" title="Parents" subtitle="Every family connected to MangoCubs." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="parents-grid">
        {parents.map(p => (
          <div key={p.parent_id} className="bg-white rounded-3xl border border-border p-5">
            <div className="flex items-center gap-3">
              <Avatar name={p.name} size={48} />
              <div>
                <div className="font-heading font-bold">{p.name}</div>
                <div className="text-xs text-ink-soft">{p.relationship} · {p.occupation}</div>
              </div>
            </div>
            <div className="mt-3 text-sm">{p.email}</div>
            <div className="mt-1 text-xs text-ink-soft">{p.phone}</div>
            <div className="mt-3 flex gap-2"><Pill tone="sage">{p.student_ids?.length || 0} child{p.student_ids?.length === 1 ? "" : "ren"}</Pill></div>
          </div>
        ))}
      </div>
    </div>
  );
}
